// extracted by mini-css-extract-plugin
export default {"loaderV2":"Loader_loaderV2__I537K","backdrop":"Loader_backdrop__IxsHz","backdropDark":"Loader_backdropDark__tK7Tu","progressContainer":"Loader_progressContainer__y5-UY"};